
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Fragment, type FC } from 'react';
import type { GetServerSideProps } from 'next';
import useTranslation from 'next-translate/useTranslation';
import { log } from '@utils/logger';
import SEO from '@components/SEO';
import { query } from '@graphql/withApollo';
import { PostsSlugsDocument, type PostsSlugsQuery } from '@graphql/generated';
import { generateFeedFiles, generateSitemap } from '@utils/SEO';
import Listing from '@components/blog/Listing';
export const BlogHome: FC<{
    data: PostsSlugsQuery;
}> = ({ data }) => {
    const { t } = useTranslation('blog');
    return (<Fragment>
      <SEO title={t('blog:title')}/>

      <Listing posts={data?.posts} rubriques={data?.rubriques}/>
    </Fragment>);
};
const getStaticProps: GetServerSideProps = async ({ locale, defaultLocale, }) => {
    const variables = {
        locales: new Set([
            ['es', 'it'].includes(locale as string) ? 'en' : locale,
            defaultLocale,
        ]),
        includeCurrent: false,
    };
    const { data, errors } = await query(PostsSlugsDocument, variables);
    await generateFeedFiles();
    await generateSitemap();
    if (errors) {
        log.error('Error loading posts', { errors });
        // TODO reconsider using 404 for this
        return { notFound: true };
    }
    return {
        props: { data },
        revalidate: 300,
    };
};
export default BlogHome;

    async function __Next_Translate__getStaticProps__1898874f6c0__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1898874f6c0__ as getStaticProps }
  